import { combineReducers } from 'redux';
import grid from './grid.reducer';
import timeSlider from './timeSlider.reducer';
import epg from './epg.reducer';
import liveOptions from './liveOptions.reducer';
import languageOptions from './languageOptions.reducer';

export default combineReducers({
  grid,
  timeSlider,
  epg,
  liveOptions,
  languageOptions,
});
